// extracted by mini-css-extract-plugin
export default {"FooterMain":"Footer_FooterMain__+tLBa","endNote":"Footer_endNote__jzu8U"};